var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('nav',{staticClass:"navigation",attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_c('span',[_vm._v("Home")])]),_c('router-link',{attrs:{"to":"/about"}},[_c('span',[_vm._v("About")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }